export default __webpack_public_path__ + "5c3a5023b7ab150f9ae9748f0a32161c.png";